var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.5C11.1236 9.5 13.25 7.37363 13.25 4.75C13.25 2.12637 11.1236 0 8.5 0C5.87637 0 3.75 2.12637 3.75 4.75C3.75 7.37363 5.87637 9.5 8.5 9.5ZM12.0551 10.7098L10.2812 17.8125L9.09375 12.7656L10.2812 10.6875H6.71875L7.90625 12.7656L6.71875 17.8125L4.94492 10.7098C2.29902 10.8359 0.1875 12.9994 0.1875 15.675V17.2188C0.1875 18.2021 0.985352 19 1.96875 19H15.0312C16.0146 19 16.8125 18.2021 16.8125 17.2188V15.675C16.8125 12.9994 14.701 10.8359 12.0551 10.7098Z",
    fill: "#F7931A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconActive);
export default __webpack_public_path__ + "static/media/profile_icon_active.401ec53bf9dd7fe703b82b10d8d40a05.svg";
export { ForwardRef as ReactComponent };